import { ComponentChildren } from 'preact'

import type {
  TeaserBodyDecoratorsProps,
  TeaserBylineProps,
  TeaserHighlightProps,
  TeaserItalicHeadlineProps,
  TeaserMediaProps,
  TeaserTextProps,
  TeaserTitleProps,
  TeaserVariantProps,
  TeaserVignetteProps,
} from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

import { IconUse } from '@bonniernews/dn-design-system-web/components/icon-sprite/icon-sprite.tsx'
import { TeaserDot } from '@bonniernews/dn-design-system-web/components/teaser-dot/teaser-dot.tsx'

interface MediaProps extends TeaserMediaProps {
  rounded?: boolean
  /** Flag so we can handle square teaser images */
  isSquareImage?: boolean
}

export const Media = ({ media, rounded, isSquareImage }: MediaProps) => {
  const classNames = formatClassString([
    'ds-teaser__media',
    rounded && 'ds-teaser__media--rounded',
    isSquareImage && 'ds-teaser__media--square-image',
  ])

  return media ? <div className={classNames}>{media}</div> : null
}

interface ContentProps extends TeaserBylineProps {
  children: ComponentChildren
}

export const Content = ({ children, bylinePicture }: ContentProps) => {
  return (
    <div className='ds-teaser__content'>
      <div className='ds-teaser__content-inner'>{children}</div>
      {bylinePicture && <div className='ds-teaser__byline'>{bylinePicture}</div>}
    </div>
  )
}

interface TeaserTitleComponentProps extends TeaserTitleProps, TeaserHighlightProps, TeaserItalicHeadlineProps {}

export const Title = ({ title, highlight, isItalicHeadline }: TeaserTitleComponentProps) => {
  return title ? (
    <h2 className={`ds-teaser__title ${isItalicHeadline ? 'ds-teaser__title--italic' : ''}`}>
      {highlight && <span className='ds-teaser__highlight'>{highlight} </span>}
      {title}
    </h2>
  ) : null
}

interface TeaserBodyComponentProps extends TeaserTextProps, TeaserBodyDecoratorsProps {}
export const Body = ({ text, sticker, isFlashingDot }: TeaserBodyComponentProps) => {
  return text ? (
    <p className='ds-teaser__text'>
      {sticker && (
        <>
          <TeaserDot flashing={isFlashingDot} />
          <span className='ds-teaser__sticker'> {sticker} </span>
        </>
      )}
      {text}
    </p>
  ) : null
}

interface VignetteComponentProps extends TeaserVignetteProps, TeaserVariantProps {}

export const Vignette = ({ vignette, variant }: VignetteComponentProps) => {
  return vignette ? (
    <div className='ds-teaser__vignette'>
      {variant === 'podcast' && <IconUse iconName='headphones' />}
      {vignette}
    </div>
  ) : null
}
